module.exports = __webpack_public_path__ + "static/media/03.54b1f5a9.png";